module.exports = __webpack_public_path__ + "img/modeloembranco.52bacec6.png";